import { createSupabaseAdminClient } from "@/lib/supabase/admin"

export type AppRole = "user" | "admin"

export type UserProfile = {
  id: string
  email: string | null
  fullName: string | null
  role: AppRole
  createdAt: string
  updatedAt: string
}

export async function getProfileByUserId(
  userId: string,
): Promise<UserProfile | null> {
  const supabase = createSupabaseAdminClient()

  const { data, error } = await supabase
    .from("profiles")
    .select("id, email, full_name, role, created_at, updated_at")
    .eq("id", userId)
    .single()

  if (error || !data) {
    console.error("Failed to load profile:", error?.message)
    return null
  }

  return {
    id: data.id,
    email: data.email,
    fullName: data.full_name,
    role: data.role,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
  }
}
